import axios from 'axios';
import config from '../config';

const shopifyPaymentApi = axios.create({
  baseURL: config.api.shopifyPaymentAppUrl,
  headers: { 'Content-Type': 'application/json', 'x-api-key': config.api.shopifyPaymentApiKey }
});

export default shopifyPaymentApi;
